import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const materialComparisonUiNodeSpec: UiNodeSpec<'materialComparison'> = {
    requiredSockets: 'all',
    cfg: () => ({
        disabled: false,
        kind: 'materialComparison',
        id: getUID(),
        controlValues: {
            comparisonCfg: {
                operation: '=',
                materialModelId: '',
                kind: 'materialModel',
            },
        },
    }),
    controls: getNodeCfg => ({
        comparisonCfg: {
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.comparisonCfg,
            cfg: {
                kind: 'materialComparisonCfg',
            },
        },
    }),
    inputs: () => ({
        materialId: { socket: 'string', label: 'Material ID' },
    }),
    kindLabel: 'Material Comparison',
    nodeCategory: 'conditional',
    outputs: () => ({
        result: { socket: 'boolean', label: 'Result' },
    }),
    validator: () => true,
};
